const appBase = {
    palette: {
        background: {
            default: '#FFFFFF',
            secondary: '#F8F8FA',
            paper: '#FFFFFF',
            hr: '#f4f4f4',
            snackbar: '#FFFFFF'
        },
        primary: {
            main: '#000000',
            dark: '#FFFFFF',
            light: '#CFCFCF',
            lighter: '#868686'
        },
        secondary: {
            main: '#f4f4f4',
            light: '#A4A4A4',
            lighter: '#919191'
        },
        error: {
            main: '#D93731',
            light: '#E57373'
        },
        info: {
            main: '#4B7594',
            light: '#ffe066'
        },
        success: {
            main: '#3A8445',
            light: '#00C61A'
        },
        warning: {
            main: '#F6C245',
            light: '#FFF477'
        },
        tonalOffset: 0.2
    }
};

export default appBase;